export default "__VITE_ASSET__Cfo5yCqY__"